import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { RootState } from "../index";

export interface AppState {
  isNavExpanded: boolean;
  language: string;
}

export const state: AppState = {
  isNavExpanded: true,
  language: "en",
};

const app: Module<AppState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};

export default app;
